/* tpb-ugc - Kundenzitat im Kaufbereich und Fotostreifen "Echte Hunde" (snippets/tpb-ugc.liquid).
   Holt die Bewertungen der Tauro-Produkte aus window.tpbUgc.ids ueber Judge.mes oeffentliche
   Widget-Schnittstelle, erst wenn die Seite fertig geladen ist. Reihenfolge: dieses Produkt (rang 0),
   dieselbe Familie (1), andere Tauro-Buersten (2). Fremde Bewertungen tragen den Buerstennamen. */
(function () {
  if (window.tpbUgcLaeuft) return;
  window.tpbUgcLaeuft = true;
  var D = window.tpbUgc;
  if (!D || !D.ids || !D.ids.length) return;
  var basis = 'https://api.judge.me/reviews/reviews_for_widget?url=' + D.dom + '&shop_domain=' + D.dom + '&platform=shopify&per_page=20&sort_by=with_pictures&page=1&product_id=';
  var STERN = '<svg viewBox="0 0 24 24"><path d="m12 2 3 6.6 7 .8-5.2 4.8 1.4 7L12 17.8 5.8 21.2l1.4-7L2 9.4l7-.8L12 2z"/></svg>';
  var fotos = [], lb = null, idx = 0;
  /* Texte aus den Sprachdateien (snippets/tpb-ugc-texte), Deutsch nur als Rueckfall */
  var T = window.tpbUgcT || {}, SPR = document.documentElement.lang || 'de';
  function tx(k, d) { return T[k] || d; }
  function fuell(s, platz, wert) { return s.split(platz).join(wert); }

  function text(html) { var d = document.createElement('div'); d.innerHTML = html || ''; return (d.textContent || '').replace(/\s+/g, ' ').trim(); }
  function klein(u, w) { return u.replace(/width=\d+/, 'width=' + w); }
  function anonym(r) { var n = (r.reviewer_name || '').trim(); return !n || r.is_anonymous_reviewer || /^anonym/i.test(n); }
  function name(r) {
    if (anonym(r)) return tx('verifizierter_kauf', 'Verifizierter Kauf');
    var t = r.reviewer_name.trim().split(/\s+/);
    return t.length > 1 ? t[0] + ' ' + t[t.length - 1].charAt(0) + '.' : t[0];
  }
  /* Ein bis zwei ganze Saetze, hoechstens ~130 Zeichen */
  function auszug(s) {
    var saetze = s.match(/[^.!?]+[.!?]+/g) || [s], out = '';
    for (var i = 0; i < saetze.length; i++) {
      var neu = (out + ' ' + saetze[i].trim()).trim();
      if (out && neu.length > 130) break;
      out = neu;
      if (out.length > 70) break;
    }
    if (out.length > 160) out = out.slice(0, 150).replace(/\s+\S*$/, '') + ' …';
    return out;
  }

  function laden() {
    Promise.all(D.ids.map(function (p) {
      return fetch(basis + p.id).then(function (r) { return r.json(); }).then(function (j) {
        return (j.primary_language_reviews || []).concat(j.other_language_reviews || []).map(function (r) { r._p = p; return r; });
      }).catch(function () { return []; });
    })).then(function (teile) {
      var alle = [], gesehen = {};
      teile.forEach(function (t) { t.forEach(function (r) { if (!gesehen[r.uuid]) { gesehen[r.uuid] = 1; alle.push(r); } }); });
      alle.sort(function (a, b) { return a._p.rang - b._p.rang || b.rating - a.rating || (b.pictures_urls || []).length - (a.pictures_urls || []).length; });
      zitat(alle);
      leiste(alle);
    });
  }

  function fremd(r) { return r._p.id !== D.pid; }
  /* Grossansicht braucht die Gestaltung aus pdp-stil-extra.css (Tauro, Rechen, Les Poochs). Fehlt sie
     (pdp-zitat auf anderen Vorlagen), springt der Klick zu den Bewertungen. */
  function lbDa() { return !!document.querySelector('link[href*="pdp-stil-extra"]'); }

  function zitat(alle) {
    var box = document.querySelector('[data-tpb-zitat]');
    if (!box) return;
    /* Gute Bewertung mit Text; bevorzugt solche, in denen ein Hund vorkommt (persoenlicher), dann die Reihenfolge */
    var HUND = /hund|welpe|r[üu]de|h[üu]ndin|pomeranian|spitz|windhund|pudel|doodle|retriever|collie|havaneser|malteser|bichon|coton|yorkie|terrier|spaniel|liebt|mag es/i;
    var r = null, gut = alle.filter(function (x) { return x.rating >= 4 && text(x.body_html).length >= 40; });
    gut.forEach(function (x) { if (!r && HUND.test(text(x.body_html))) r = x; });
    if (!r) r = gut[0];
    if (!r) return;
    var bild = (r.pictures_urls || [])[0];
    var sterne = '';
    for (var k = 0; k < r.rating; k++) sterne += STERN;
    box.innerHTML = (bild ? '<span class="tpb-zitat-bild"><img src="' + klein(bild.original, 160) + '" alt="" loading="lazy"></span>' : '')
      + '<span class="tpb-zitat-txt"><q></q><span class="tpb-zitat-wer"><span class="tpb-zitat-sterne" aria-label="' + fuell(tx('sterne', '__N__ von 5 Sternen'), '__N__', r.rating) + '">' + sterne + '</span><b></b><span class="tpb-zitat-zu"></span></span></span>';
    box.querySelector('q').textContent = auszug(text(r.body_html));
    box.querySelector('b').textContent = name(r);
    box.querySelector('.tpb-zitat-zu').textContent = fremd(r) ? '· ' + fuell(tx('zur', 'zur __NAME__'), '__NAME__', r._p.name) : (r.verified_buyer && !anonym(r) ? '· ' + tx('verifiziert_klein', 'verifiziert') : '');
    box.hidden = false;
    platzieren(box);
    box.addEventListener('click', function (e) {
      var i = -1;
      fotos.forEach(function (f, k) { if (i < 0 && f.r === r) i = k; });
      if (i >= 0 && lbDa()) { e.preventDefault(); oeffnen(i); }
      else if (!document.getElementById('tpb-ugc') || document.getElementById('tpb-ugc').hidden) {
        var ziel = document.querySelector('.jdgm-widget.jdgm-review-widget');
        if (ziel) { e.preventDefault(); ziel.scrollIntoView({ behavior: 'smooth' }); }
      }
    });
  }

  /* Desktop (Galerie und Kaufbox nebeneinander): das Zitat sitzt unter den Bildern im sonst leeren
     Raum der linken Spalte. Schmal (Handy, Tablet hoch): zurueck an seinen Platz in der Kaufbox. */
  function platzieren(box) {
    var gal = document.querySelector('#main-product .l4pr-container'), kauf = document.querySelector('#main-product .f8pr');
    if (!gal || !kauf) return;
    var marke = document.createComment('tpb-zitat');
    box.parentNode.insertBefore(marke, box);
    /* Links buendig mit den Vorschaubildern (die Leiste sitzt links neben dem Hauptbild), nicht nur so breit wie das Hauptbild */
    function buendig() {
      box.style.marginLeft = '';
      if (box.parentNode !== gal) return;
      var leiste = gal.querySelector('.swiper-custom-pagination');
      if (!leiste || !leiste.getBoundingClientRect().width) return;
      var d = leiste.getBoundingClientRect().left - box.getBoundingClientRect().left;
      if (d < -1) box.style.marginLeft = Math.round(d) + 'px';
    }
    function pruefen() {
      var nebeneinander = gal.getBoundingClientRect().right <= kauf.getBoundingClientRect().left + 2;
      if (nebeneinander && box.parentNode !== gal) {
        /* Stehen unter der Galerie schon Klappfelder (teleport_accordion der Standardvorlage), kommt das Zitat davor */
        var acc = gal.querySelector(':scope > .desktop-only-wrapper');
        if (acc && acc.children.length) gal.insertBefore(box, acc); else gal.appendChild(box);
        box.classList.add('tpb-zitat-links');
      }
      else if (!nebeneinander && box.parentNode === gal) { marke.parentNode.insertBefore(box, marke.nextSibling); box.classList.remove('tpb-zitat-links'); }
      buendig();
    }
    setTimeout(buendig, 1500);
    pruefen();
    window.addEventListener('resize', pruefen);
  }

  function leiste(alle) {
    alle.forEach(function (r) { (r.pictures_urls || []).forEach(function (u) { if (u && u.original && fotos.length < 16) fotos.push({ url: u.original, r: r }); }); });
    var wurzel = document.querySelector('[data-tpb-ugc]');
    if (!wurzel || fotos.length < 3) return;
    var spur = wurzel.querySelector('[data-tpb-ugc-spur]');
    fotos.forEach(function (f, k) {
      var b = document.createElement('button');
      b.type = 'button'; b.className = 'tpb-ugc-bild'; b.setAttribute('data-i', k);
      b.setAttribute('aria-label', fuell(tx('foto_gross', 'Kundenfoto __N__ vergrößern'), '__N__', k + 1));
      b.innerHTML = '<img src="' + klein(f.url, 400) + '" alt="" loading="lazy">';
      if (fremd(f.r)) { var m = document.createElement('span'); m.className = 'tpb-ugc-marke'; m.textContent = f.r._p.name; b.appendChild(m); }
      spur.appendChild(b);
    });
    wurzel.hidden = false;
    var zur = wurzel.querySelector('.tpb-ugc-zurueck'), vor = wurzel.querySelector('.tpb-ugc-vor');
    function pfeile() { zur.disabled = spur.scrollLeft < 4; vor.disabled = spur.scrollLeft + spur.clientWidth > spur.scrollWidth - 4; }
    zur.addEventListener('click', function () { spur.scrollBy({ left: -spur.clientWidth * 0.8, behavior: 'smooth' }); });
    vor.addEventListener('click', function () { spur.scrollBy({ left: spur.clientWidth * 0.8, behavior: 'smooth' }); });
    spur.addEventListener('scroll', pfeile, { passive: true });
    window.addEventListener('resize', pfeile);
    pfeile();
    spur.addEventListener('click', function (e) { var b = e.target.closest('.tpb-ugc-bild'); if (b) oeffnen(+b.getAttribute('data-i')); });
  }

  /* Grossansicht: dasselbe Markup wie die Kundenfoto-Ansicht der Bewertungen (.bw-lb in pdp-stil-extra.css) */
  function bauLb() {
    var pf = function (d) { return '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round"><path d="' + d + '"/></svg>'; };
    lb = document.createElement('div');
    lb.className = 'bw-lb';
    var at = function (k, d) { return tx(k, d).replace(/"/g, '&quot;'); };
    lb.innerHTML = '<div class="bw-lb-grund"></div><div class="bw-lb-karte" role="dialog" aria-modal="true" aria-label="' + at('kundenfoto', 'Kundenfoto') + '">'
      + '<button type="button" class="bw-lb-zu" aria-label="' + at('schliessen', 'Schließen') + '"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round"><path d="M6 6l12 12M18 6L6 18"/></svg></button>'
      + '<div class="bw-lb-bild"><img alt=""><button type="button" class="bw-lb-pfeil bw-lb-zurueck" aria-label="' + at('foto_zurueck', 'Vorheriges Foto') + '">' + pf('M15 18l-6-6 6-6') + '</button>'
      + '<button type="button" class="bw-lb-pfeil bw-lb-vor" aria-label="' + at('foto_vor', 'Nächstes Foto') + '">' + pf('M9 6l6 6-6 6') + '</button><span class="bw-lb-zahl"></span></div>'
      + '<div class="bw-lb-text"></div></div>';
    document.body.appendChild(lb);
    lb.querySelector('.bw-lb-grund').addEventListener('click', zu);
    lb.querySelector('.bw-lb-zu').addEventListener('click', zu);
    lb.querySelector('.bw-lb-zurueck').addEventListener('click', function () { zeigen(idx - 1); });
    lb.querySelector('.bw-lb-vor').addEventListener('click', function () { zeigen(idx + 1); });
    document.addEventListener('keydown', function (e) {
      if (!lb.classList.contains('offen')) return;
      if (e.key === 'Escape') zu();
      if (e.key === 'ArrowLeft') zeigen(idx - 1);
      if (e.key === 'ArrowRight') zeigen(idx + 1);
    });
    var x0 = null, bild = lb.querySelector('.bw-lb-bild');
    bild.addEventListener('touchstart', function (e) { x0 = e.touches[0].clientX; }, { passive: true });
    bild.addEventListener('touchend', function (e) { if (x0 === null) return; var dx = e.changedTouches[0].clientX - x0; x0 = null; if (Math.abs(dx) > 40) zeigen(idx + (dx < 0 ? 1 : -1)); });
  }
  function zeigen(i) {
    var n = fotos.length; idx = (i + n) % n;
    var f = fotos[idx], r = f.r;
    lb.querySelector('.bw-lb-bild img').src = f.url;
    lb.querySelector('.bw-lb-zahl').textContent = (idx + 1) + ' / ' + n;
    lb.querySelectorAll('.bw-lb-pfeil,.bw-lb-zahl').forEach(function (e) { e.style.display = n > 1 ? '' : 'none'; });
    var t = lb.querySelector('.bw-lb-text'); t.innerHTML = '';
    function el(tag, cls, txt) { var e = document.createElement(tag); e.className = cls; if (txt != null) e.textContent = txt; t.appendChild(e); return e; }
    if (r.verified_buyer) el('span', 'bw-lb-tag', tx('verifiziert', 'Verifiziert'));
    el('div', 'bw-lb-name', name(r));
    var d = r.created_at ? new Date(r.created_at).toLocaleDateString(SPR, { day: '2-digit', month: '2-digit', year: 'numeric' }) : '';
    el('div', 'bw-lb-meta', [fremd(r) ? fuell(tx('bewertung_zur', 'Bewertung zur __NAME__'), '__NAME__', r._p.name) : '', r.location_country, d].filter(Boolean).join(' · '));
    var s = el('div', 'bw-lb-sterne'); s.setAttribute('aria-label', fuell(tx('sterne', '__N__ von 5 Sternen'), '__N__', r.rating));
    for (var k = 1; k <= 5; k++) s.insertAdjacentHTML('beforeend', STERN.replace('<svg ', '<svg fill="' + (k <= r.rating ? '#ffb700' : '#e8e2d5') + '" '));
    if (r.title && text(r.title) !== text(r.body_html).slice(0, text(r.title).length)) el('div', 'bw-lb-titel', r.title);
    el('div', 'bw-lb-body').innerHTML = r.body_html || '';
  }
  function oeffnen(i) {
    if (!lb) bauLb();
    zeigen(i);
    lb.classList.add('offen');
    document.documentElement.style.overflow = 'hidden';
    lb.querySelector('.bw-lb-zu').focus();
  }
  function zu() { lb.classList.remove('offen'); document.documentElement.style.overflow = ''; }

  function start() { if ('requestIdleCallback' in window) requestIdleCallback(laden, { timeout: 2500 }); else setTimeout(laden, 600); }
  if (document.readyState === 'complete') start(); else window.addEventListener('load', start);
})();
